const compliancePopupLogoBaseCss = `
    display: block;
    height: auto;
    margin: 0 auto;
`;

/** Default blocking popup logo — matches website 229px / 261px (tablet). */
export const compliancePopupLogoCss = `
    ${compliancePopupLogoBaseCss}
    max-width: min(261px, 70vw);
    width: 229px;

    @media (min-width: 768px) {
        width: 261px;
    }
`;

export const compliancePopupLogoCssDragonbet = `
    ${compliancePopupLogoBaseCss}
    max-width: min(262px, 70vw);
    width: 228px;

    @media (min-width: 768px) {
        width: 262px;
    }
`;

export const compliancePopupLogoCssEnergy = `
    ${compliancePopupLogoBaseCss}
    max-width: min(128px, 70vw);
    width: 112px;

    @media (min-width: 768px) {
        width: 128px;
    }
`;

export const compliancePopupLogoCssMcbookie = `
    ${compliancePopupLogoBaseCss}
    max-width: min(202px, 70vw);
    width: 177px;

    @media (min-width: 768px) {
        width: 202px;
    }
`;
